"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserFeedbackScore = void 0;
exports.UserFeedbackScore = {
    Like: "like",
    Dislike: "dislike",
};
